import * as React from "react";

React.lazy(() =>
    import(
        /* webpackMode: "eager" */ "@omni/components/components/BannerSlider/bannerSlider.default"
    ).then((module) => ({ default: module.BannerSliderDefault }))
);
